import { createSelector } from '@reduxjs/toolkit'
import { sectorRulesSlice } from '..'

export const sectorRulesPayloadSelector = createSelector(
  [
    sectorRulesSlice.selectors.rules,
    sectorRulesSlice.selectors.preemptionCode,
    (_state: unknown, period: { end: number } | null) => period,
  ],
  (sectorRules, preemptionCode, period): Record<string, string> | null => {
    if (!sectorRules || sectorRules.length === 0) {
      return null
    }
    const payload = sectorRules.reduce<Record<string, string>>(
      (acc, sectorRule) => {
        switch (sectorRule.ruleType) {
          case 'arrival-date': {
            if (period !== null) {
              acc.endDate = String(period.end)
            }
            break
          }
          case 'preemption-code-validation': {
            if (preemptionCode !== null) {
              acc.preemptionCode = preemptionCode
            }
            break
          }
        }
        return acc
      },
      {}
    )

    return Object.keys(payload).length > 0 ? payload : null
  }
)
